export const getCommunicationTemplateList = state => {
    return state.list
}

export const getCommunicationTemplateDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/communicationTemplate/getters.js